@for (step of stepRouter.steps; track step.id; let index = $index) {
	<prism-step [label]="step.label">
		@if (stepRouter.activeStepNumber() === $index) {
			<div class="step-container">
				<ng-container *ngComponentOutlet="step.component()" />
			</div>
		}
	</prism-step>
}
